import {createAction, handleActions} from 'redux-actions';
import {applyMiddleware, combineReducers, createStore, Store} from "redux";
import promiseMiddleware from 'redux-promise-middleware';
import {FrameMeta} from "./problem-domain/frame";
import {ProgramIndex} from "./bridge";

export interface GlobalState {
    index: ProgramIndex;
    version: string;
}

export namespace Actions {
    export const updateVersion = createAction<string>("UPDATE_VERSION");
    export const updateIndex = createAction<FrameMeta[]>("UPDATE_INDEX");
}

export const defaultState: GlobalState = {
    index: {
        frames: [],
        version: 0.0,
        tagVersion: "unknown"
    },
    version: "__LOADING__"
};

const versionReducer = handleActions({
    UPDATE_VERSION_FULFILLED: (state: GlobalState, action) => {
        return action.payload;
    },
    UPDATE_VERSION_REJECTED: (state, action) => {
        alert(action.payload);
        return "failed";
    },
}, defaultState.version);

const indexReducer = handleActions({
    UPDATE_INDEX_FULFILLED: (state: GlobalState, action) => {
        return action.payload;
    },

    UPDATE_INDEX_REJECTED: (state, action) => {
        alert(action.payload);
        return state;
    },
}, defaultState.index);

const reducer = combineReducers<GlobalState>({
    index: indexReducer,
    version: versionReducer
});

export const store: Store<GlobalState> = applyMiddleware(
    promiseMiddleware()
)(createStore)(reducer, defaultState);

export const waitVersion: Promise<string> = new Promise((resolve, reject) => {
        const version = store.getState().version;
        if (version !== "__LOADING__") {
            resolve(version);
        } else {
            const unsubscribe = store.subscribe(() => {
                const version = store.getState().version;
                if (version !== "__LOADING__") {
                    unsubscribe();
                    resolve(version);
                }
            });
        }
    }
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reduxSetting.tsx